import React, { useState } from 'react';
import { PlusIcon, ThumbsUpIcon, ThumbsDownIcon } from 'lucide-react';
export function WardrobeSection({
  userProfile = {}
}) {
  const [activeTab, setActiveTab] = useState('tops');
  const [feedback, setFeedback] = useState({});
  // Base wardrobe items organized by gender and age ranges
  const allWardrobeItems = {
    female: {
      young: {
        tops: [{
          id: 1,
          name: 'Crop Top',
          image: 'https://images.unsplash.com/photo-1583744946564-b52d01a7e11e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 2,
          name: 'Graphic Tee',
          image: 'https://images.unsplash.com/photo-1503342394128-c104d54dba01?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 3,
          name: 'Oversized Sweater',
          image: 'https://images.unsplash.com/photo-1576871337622-98d48d1cf531?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        bottoms: [{
          id: 4,
          name: 'High-Waisted Jeans',
          image: 'https://images.unsplash.com/photo-1541099649105-f69ad21f3246?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 5,
          name: 'Mini Skirt',
          image: 'https://images.unsplash.com/photo-1583496661160-fb5886a0aaaa?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        shoes: [{
          id: 6,
          name: 'Platform Sneakers',
          image: 'https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 7,
          name: 'Ankle Boots',
          image: 'https://images.unsplash.com/photo-1543163521-1bf559a7a30e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        accessories: [{
          id: 8,
          name: 'Hoop Earrings',
          image: 'https://images.unsplash.com/photo-1630019852942-f89202989a59?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 9,
          name: 'Bucket Hat',
          image: 'https://images.unsplash.com/photo-1607611439230-fcbf50e42f5c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }]
      },
      middle: {
        tops: [{
          id: 10,
          name: 'Silk Blouse',
          image: 'https://images.unsplash.com/photo-1602697196016-3a2a3a0f294e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 11,
          name: 'Cashmere Sweater',
          image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 12,
          name: 'Tailored Blazer',
          image: 'https://images.unsplash.com/photo-1591369822096-ffd140ec948f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        bottoms: [{
          id: 13,
          name: 'Straight Leg Trousers',
          image: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 14,
          name: 'Midi Skirt',
          image: 'https://images.unsplash.com/photo-1577744486770-2f42ffcb6b9b?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        shoes: [{
          id: 15,
          name: 'Leather Pumps',
          image: 'https://images.unsplash.com/photo-1543163521-1bf559a7a30e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 16,
          name: 'Loafers',
          image: 'https://images.unsplash.com/photo-1626947346165-4c2288dadc2a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        accessories: [{
          id: 17,
          name: 'Pearl Earrings',
          image: 'https://images.unsplash.com/photo-1588444837495-c6cfeb53f32d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 18,
          name: 'Structured Handbag',
          image: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }]
      },
      senior: {
        tops: [{
          id: 19,
          name: 'Cardigan',
          image: 'https://images.unsplash.com/photo-1618246512392-706147903705?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 20,
          name: 'Button-Up Blouse',
          image: 'https://images.unsplash.com/photo-1598033129183-c4f50c736f10?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 21,
          name: 'Lightweight Sweater',
          image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        bottoms: [{
          id: 22,
          name: 'Classic Slacks',
          image: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 23,
          name: 'A-Line Skirt',
          image: 'https://images.unsplash.com/photo-1577744486770-2f42ffcb6b9b?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        shoes: [{
          id: 24,
          name: 'Comfortable Flats',
          image: 'https://images.unsplash.com/photo-1491897554428-130a60dd4757?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 25,
          name: 'Low-Heel Pumps',
          image: 'https://images.unsplash.com/photo-1518049362265-d5b2a6467637?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        accessories: [{
          id: 26,
          name: 'Silk Scarf',
          image: 'https://images.unsplash.com/photo-1520903920243-00d872a2d1c9?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 27,
          name: 'Classic Watch',
          image: 'https://images.unsplash.com/photo-1524592094714-0f0654e20314?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }]
      }
    },
    male: {
      young: {
        tops: [{
          id: 28,
          name: 'Graphic Tee',
          image: 'https://images.unsplash.com/photo-1576871337622-98d48d1cf531?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 29,
          name: 'Hoodie',
          image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 30,
          name: 'Denim Jacket',
          image: 'https://images.unsplash.com/photo-1551537482-f2075a1d41f2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        bottoms: [{
          id: 31,
          name: 'Distressed Jeans',
          image: 'https://images.unsplash.com/photo-1604176354204-9268737828e4?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 32,
          name: 'Joggers',
          image: 'https://images.unsplash.com/photo-1580906853203-f13ea293a5ec?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        shoes: [{
          id: 33,
          name: 'High-Top Sneakers',
          image: 'https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 34,
          name: 'Skate Shoes',
          image: 'https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        accessories: [{
          id: 35,
          name: 'Beanie',
          image: 'https://images.unsplash.com/photo-1576871337632-b9aef4c17ab9?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 36,
          name: 'Snapback Cap',
          image: 'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }]
      },
      middle: {
        tops: [{
          id: 37,
          name: 'Button-Down Shirt',
          image: 'https://images.unsplash.com/photo-1598033129183-c4f50c736f10?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 38,
          name: 'Polo Shirt',
          image: 'https://images.unsplash.com/photo-1563630423918-b58f07336ac9?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 39,
          name: 'V-Neck Sweater',
          image: 'https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        bottoms: [{
          id: 40,
          name: 'Chinos',
          image: 'https://images.unsplash.com/photo-1473966968600-fa801b869a1a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 41,
          name: 'Dark Wash Jeans',
          image: 'https://images.unsplash.com/photo-1604176354204-9268737828e4?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        shoes: [{
          id: 42,
          name: 'Leather Loafers',
          image: 'https://images.unsplash.com/photo-1478146896981-b80fe463b330?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 43,
          name: 'Casual Leather Shoes',
          image: 'https://images.unsplash.com/photo-1605812860427-4024433a70fd?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        accessories: [{
          id: 44,
          name: 'Leather Belt',
          image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 45,
          name: 'Dress Watch',
          image: 'https://images.unsplash.com/photo-1522312346375-d1a52e2b99b3?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }]
      },
      senior: {
        tops: [{
          id: 46,
          name: 'Cardigan',
          image: 'https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 47,
          name: 'Oxford Shirt',
          image: 'https://images.unsplash.com/photo-1598033129183-c4f50c736f10?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 48,
          name: 'Lightweight Jacket',
          image: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        bottoms: [{
          id: 49,
          name: 'Relaxed Fit Trousers',
          image: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 50,
          name: 'Classic Jeans',
          image: 'https://images.unsplash.com/photo-1604176354204-9268737828e4?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        shoes: [{
          id: 51,
          name: 'Comfort Loafers',
          image: 'https://images.unsplash.com/photo-1478146896981-b80fe463b330?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 52,
          name: 'Walking Shoes',
          image: 'https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }],
        accessories: [{
          id: 53,
          name: 'Classic Hat',
          image: 'https://images.unsplash.com/photo-1521369909029-2afed882baee?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }, {
          id: 54,
          name: 'Reading Glasses',
          image: 'https://images.unsplash.com/photo-1577803645773-f96470509666?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
        }]
      }
    },
    nonbinary: {
      // Universal items that work for all non-binary ages
      tops: [{
        id: 55,
        name: 'Oversized Tee',
        image: 'https://images.unsplash.com/photo-1576871337622-98d48d1cf531?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }, {
        id: 56,
        name: 'Button-Up Shirt',
        image: 'https://images.unsplash.com/photo-1598033129183-c4f50c736f10?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }, {
        id: 57,
        name: 'Denim Jacket',
        image: 'https://images.unsplash.com/photo-1551537482-f2075a1d41f2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }],
      bottoms: [{
        id: 58,
        name: 'Straight Leg Jeans',
        image: 'https://images.unsplash.com/photo-1604176354204-9268737828e4?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }, {
        id: 59,
        name: 'Wide Leg Pants',
        image: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }],
      shoes: [{
        id: 60,
        name: 'Canvas Sneakers',
        image: 'https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }, {
        id: 61,
        name: 'Combat Boots',
        image: 'https://images.unsplash.com/photo-1608256246200-53e635b5b65f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }],
      accessories: [{
        id: 62,
        name: 'Beanie',
        image: 'https://images.unsplash.com/photo-1576871337632-b9aef4c17ab9?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }, {
        id: 63,
        name: 'Minimalist Watch',
        image: 'https://images.unsplash.com/photo-1524592094714-0f0654e20314?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }]
    },
    default: {
      // Default items for when no gender is selected or "Prefer not to say"
      tops: [{
        id: 1,
        name: 'White T-shirt',
        image: 'https://images.unsplash.com/photo-1581655353564-df123a1eb820?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }, {
        id: 2,
        name: 'Blue Polo',
        image: 'https://images.unsplash.com/photo-1563630423918-b58f07336ac9?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }, {
        id: 3,
        name: 'Black Sweater',
        image: 'https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }],
      bottoms: [{
        id: 4,
        name: 'Blue Jeans',
        image: 'https://images.unsplash.com/photo-1475178626620-a4d074967452?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }, {
        id: 5,
        name: 'Black Pants',
        image: 'https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }],
      shoes: [{
        id: 6,
        name: 'Sneakers',
        image: 'https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }, {
        id: 7,
        name: 'Boots',
        image: 'https://images.unsplash.com/photo-1605812860427-4024433a70fd?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }],
      accessories: [{
        id: 8,
        name: 'Sunglasses',
        image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }, {
        id: 9,
        name: 'Watch',
        image: 'https://images.unsplash.com/photo-1522312346375-d1a52e2b99b3?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }]
    }
  };
  // Replacement items when user gives thumbs down
  const replacementItems = {
    tops: [{
      id: 101,
      name: 'Striped Button-Up',
      image: 'https://images.unsplash.com/photo-1596755094514-f87e34085b2c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }, {
      id: 102,
      name: 'Floral Blouse',
      image: 'https://images.unsplash.com/photo-1564257631407-4deb1f99d992?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }, {
      id: 103,
      name: 'Knit Cardigan',
      image: 'https://images.unsplash.com/photo-1626497764746-6dc36546b388?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }, {
      id: 104,
      name: 'Turtleneck Sweater',
      image: 'https://images.unsplash.com/photo-1608744882201-52a7f7f3dd60?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }],
    bottoms: [{
      id: 105,
      name: 'Pleated Trousers',
      image: 'https://images.unsplash.com/photo-1551854838-212c9a5fcb70?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }, {
      id: 106,
      name: 'Cargo Pants',
      image: 'https://images.unsplash.com/photo-1583846783214-7229a91b20ed?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }, {
      id: 107,
      name: 'Linen Shorts',
      image: 'https://images.unsplash.com/photo-1591195853828-11db59a44f6b?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }],
    shoes: [{
      id: 108,
      name: 'Leather Oxfords',
      image: 'https://images.unsplash.com/photo-1573100925118-870b8efc799d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }, {
      id: 109,
      name: 'Espadrilles',
      image: 'https://images.unsplash.com/photo-1562273138-f46be4ebdf33?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }, {
      id: 110,
      name: 'Slip-On Sneakers',
      image: 'https://images.unsplash.com/photo-1608231387042-66d1773070a5?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }],
    accessories: [{
      id: 111,
      name: 'Leather Crossbody',
      image: 'https://images.unsplash.com/photo-1591561954557-26941169b49e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }, {
      id: 112,
      name: 'Statement Necklace',
      image: 'https://images.unsplash.com/photo-1599643477877-530eb83abc8e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }, {
      id: 113,
      name: 'Knit Scarf',
      image: 'https://images.unsplash.com/photo-1609803384069-19f3e4a20c0a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }]
  };
  // Get appropriate wardrobe items based on user profile
  const getWardrobeItems = () => {
    const {
      gender,
      ageRange
    } = userProfile;
    // If no gender or age is selected, return default items
    if (!gender || gender === 'Prefer not to say') {
      return allWardrobeItems.default;
    }
    // Determine age category
    let ageCategory = 'young';
    if (ageRange) {
      const age = parseInt(ageRange.split('-')[0]);
      if (age >= 55) {
        ageCategory = 'senior';
      } else if (age >= 35) {
        ageCategory = 'middle';
      }
    }
    // Map gender to our data structure
    let genderCategory = 'default';
    if (gender === 'Female') genderCategory = 'female';else if (gender === 'Male') genderCategory = 'male';else if (gender === 'Non-binary') genderCategory = 'nonbinary';
    // For non-binary, we don't differentiate by age
    if (genderCategory === 'nonbinary') {
      return allWardrobeItems.nonbinary;
    }
    // Return appropriate items based on gender and age
    return allWardrobeItems[genderCategory]?.[ageCategory] || allWardrobeItems.default;
  };
  // Get the base wardrobe items
  const [wardrobeItems, setWardrobeItems] = useState(getWardrobeItems());
  // Handle thumbs up
  const handleThumbsUp = itemId => {
    setFeedback(prev => ({
      ...prev,
      [itemId]: 'up'
    }));
  };
  // Handle thumbs down - replace the item
  const handleThumbsDown = itemId => {
    // Mark as disliked in feedback
    setFeedback(prev => ({
      ...prev,
      [itemId]: 'down'
    }));
    // Find which category the item is in
    const category = activeTab;
    // Get a random replacement item from the replacement pool for that category
    const replacementPool = replacementItems[category];
    if (!replacementPool || replacementPool.length === 0) return;
    const randomIndex = Math.floor(Math.random() * replacementPool.length);
    const replacementItem = replacementPool[randomIndex];
    // Update the wardrobe items
    setWardrobeItems(prev => {
      const newItems = {
        ...prev
      };
      // Find the item to replace
      const itemIndex = newItems[category].findIndex(item => item.id === itemId);
      if (itemIndex !== -1) {
        // Replace it with the new item
        newItems[category] = [...newItems[category].slice(0, itemIndex), replacementItem, ...newItems[category].slice(itemIndex + 1)];
      }
      return newItems;
    });
    // Remove the used replacement item from the pool
    replacementItems[category] = replacementItems[category].filter(item => item.id !== replacementItem.id);
  };
  return <div id="wardrobe" className="bg-white rounded-xl shadow-md p-6 h-full" data-id="element-228">
      <div className="flex items-center justify-between mb-4" data-id="element-229">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-230">My Wardrobe</h2>
        <button className="flex items-center space-x-1 text-indigo-600 hover:text-indigo-800" data-id="element-231">
          <PlusIcon className="h-4 w-4" data-id="element-232" />
          <span className="text-sm" data-id="element-233">Add Item</span>
        </button>
      </div>
      {(userProfile.gender || userProfile.ageRange) && <div className="mb-3 text-sm text-gray-600" data-id="element-234">
          {userProfile.gender && <span data-id="element-235">Showing items for {userProfile.gender} </span>}
          {userProfile.ageRange && <span data-id="element-236">in age range {userProfile.ageRange}</span>}
        </div>}
      <div className="flex border-b border-gray-200" data-id="element-237">
        {Object.keys(wardrobeItems).map(category => <button key={category} className={`px-4 py-2 text-sm font-medium ${activeTab === category ? 'border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab(category)} data-id="element-238">
            {category.charAt(0).toUpperCase() + category.slice(1)}
          </button>)}
      </div>
      <div className="mt-4" data-id="element-239">
        <div className="grid grid-cols-2 gap-3" data-id="element-240">
          {wardrobeItems[activeTab].map(item => <div key={item.id} className="bg-gray-50 rounded-lg overflow-hidden" data-id="element-241">
              <div className="aspect-w-1 aspect-h-1 relative" data-id="element-242">
                <img src={item.image} alt={item.name} className="object-cover w-full h-full" data-id="element-243" />
                <div className="absolute top-2 right-2 flex space-x-1" data-id="element-244">
                  <button onClick={() => handleThumbsUp(item.id)} className={`p-1 rounded-full ${feedback[item.id] === 'up' ? 'bg-green-500 text-white' : 'bg-white/80 text-gray-600 hover:bg-green-100'}`} data-id="element-245">
                    <ThumbsUpIcon className="h-4 w-4" data-id="element-246" />
                  </button>
                  <button onClick={() => handleThumbsDown(item.id)} className={`p-1 rounded-full ${feedback[item.id] === 'down' ? 'bg-red-500 text-white' : 'bg-white/80 text-gray-600 hover:bg-red-100'}`} data-id="element-247">
                    <ThumbsDownIcon className="h-4 w-4" data-id="element-248" />
                  </button>
                </div>
              </div>
              <div className="p-2" data-id="element-249">
                <p className="text-sm font-medium text-gray-900 truncate" data-id="element-250">
                  {item.name}
                </p>
              </div>
            </div>)}
          <div className="flex items-center justify-center bg-gray-50 rounded-lg border-2 border-dashed border-gray-300 p-4" data-id="element-251">
            <button className="flex flex-col items-center text-gray-500 hover:text-indigo-600" data-id="element-252">
              <PlusIcon className="h-8 w-8" data-id="element-253" />
              <span className="mt-1 text-xs" data-id="element-254">Add {activeTab.slice(0, -1)}</span>
            </button>
          </div>
        </div>
      </div>
    </div>;
}